import PropTypes from "prop-types";
import React from "react";
import attestationMotoScan from "../../../../assets/img/scan_att.jpg";
import signature from "../../../../assets/img/cachet.png";
import { frenchDateOnly, splitNameStringForPrintingAttestation } from "../../../../variables/functions";

const AttestationMoto = React.forwardRef((props, ref) => {
  const completeName = props.engin?.conducteurHabituel ? props.engin?.conducteurHabituel?.nom + " " + props.engin?.conducteurHabituel?.prenom : props.engin?.personne?.nom + " " + props.engin?.personne?.prenom;
  return (
    <div className="container">
      <div
        ref={ref}
        className=""
        style={{
          height: 400,
          width: 1080,
          backgroundImage: `url(${attestationMotoScan})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "absolute",
        }}
      >
        <div className="row">
          <div className="col" style={{ position: "relative" }}>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "20px",
                marginTop: "65px",
                fontSize: "12px",
              }}
            >
              <b>
                {props.engin?.conducteurHabituel?.nom || props.engin?.personne?.nom || props.contrat?.souscripteur?.nom}{" "}
                {props.engin?.conducteurHabituel?.prenom || props.engin?.personne?.prenom || props.contrat?.souscripteur?.prenom || ""}{" "}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "20px",
                marginTop: "80px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.conducteurHabituel?.contact[0] || props.engin?.personne?.contact[0] || props.contrat?.souscripteur?.contact[0] || " "}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "75px",
                marginTop: "95px",
                fontSize: "12px",
              }}
            >
              <b>
                {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "37px",
                marginTop: "110px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "125px",
                marginTop: "110px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "115px",
                marginTop: "126px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "112px",
                marginTop: "143px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "78px",
                marginTop: "160px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "80px",
                marginTop: "176px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "15px",
                marginTop: "210px",
                fontSize: "11px",
              }}
            >
              Imprimée à {props.contrat?.producteur?.agence?.typeAgence === "SIEGE" ? "LOME (Siège)" : props.contrat?.producteur?.agence?.ville} le {props?.contrat?.dateImpressionAttestation ? props?.contrat?.dateImpressionAttestation?.split("T")[0] : props?.contrat.createdAt?.split("T")[0]}
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "15px",
                marginTop: "220px",
                fontSize: "11px",
              }}
            >
              par {props.contrat?.producteur?.codeId}
            </h6>
          </div>
          <div className="col">
            <h6
              className=""
              style={{
                position: "absolute",
                marginLeft: "-40px",
                marginTop: "98px",
                fontSize: "12px",
              }}
            >
              <b>
                {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-81px",
                marginTop: "115px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "7px",
                marginTop: "115px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-3px",
                marginTop: "132px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-4px",
                marginTop: "150px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-39px",
                marginTop: "165px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-50px",
                marginTop: "181px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "10px",
                marginTop: "198px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.usage || "_"}</b>
            </h6>
          </div>
          <div className="col">
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-82px",
                marginTop: "20px",
                fontSize: "12px",
              }}
            >
              <b>
                {
                  splitNameStringForPrintingAttestation(
                    `${completeName || props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                    21,
                  ).firstLine
                }
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-217px",
                marginTop: "46px",
                fontSize: "12px",
              }}
            >
              <b>
                {
                  splitNameStringForPrintingAttestation(
                    `${completeName || props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.nom + " " + props.contrat?.souscripteur?.prenom : props.contrat?.souscripteur?.nom}`,
                    21,
                  ).secondLine
                }{" "}
                {props.contrat?.souscripteur?.adresse || "_"}{" "}
                {props.contrat?.souscripteur?.contact?.[0] || ""}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-150px",
                marginTop: "64px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.conducteurHabituel ? props.engin?.conducteurHabituel?.profession : props.engin?.personne?.profession || props.contrat?.souscripteur?.profession || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-153px",
                marginTop: "81px",
                fontSize: "12px",
              }}
            >
              <b>
                {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-180px",
                marginTop: "107px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-65px",
                marginTop: "107px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-120px",
                marginTop: "128px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-122px",
                marginTop: "145px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-155px",
                marginTop: "162px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-135px",
                marginTop: "180px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || "-"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-55px",
                marginTop: "197px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.usage || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-182px",
                marginTop: "243px",
                fontSize: "12px",
              }}
            >
              <b>App. Terrestre</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-32px",
                marginTop: "243px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-100px",
                marginTop: "257px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "105px",
                marginTop: "190px",
              }}
            >
              <img style={{ width: "60%" }} alt="Signature" src={signature} />
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
});
AttestationMoto.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
  printing: PropTypes.bool,
};
AttestationMoto.displayName = "Attestation Moto";

export default AttestationMoto;
